import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React, { useMemo } from "react";
import { Link, useRouteMatch } from "react-router-dom";

export const NavLink = ({
  to,
  dataTestId,
  title,
  icon,
}: {
  to: string;
  dataTestId: string;
  title: string;
  icon?: React.ReactNode;
}) => {
  const { url } = useRouteMatch();
  const isCurrent = useMemo(() => url === to, [url, to]);

  return (
    <ListItem disablePadding>
      <ListItemButton
        component={Link}
        to={to}
        data-testid={dataTestId}
        selected={isCurrent}
        sx={{
          borderRadius: 1,
          mx: 0.5,
          "&.Mui-selected": {
            bgcolor: "primary.main",
            color: "white",
            "& .MuiListItemIcon-root": { color: "white" },
            "&:hover": { bgcolor: "primary.dark" },
          },
        }}
      >
        {icon && <ListItemIcon sx={{ minWidth: 36 }}>{icon}</ListItemIcon>}
        <ListItemText
          primary={title}
          primaryTypographyProps={{
            fontSize: 14,
            fontWeight: isCurrent ? 600 : 400,
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};
